import { render, staticRenderFns } from "./ProductPartFour.vue?vue&type=template&id=43ae9659&scoped=true&"
import script from "./ProductPartFour.vue?vue&type=script&lang=js&"
export * from "./ProductPartFour.vue?vue&type=script&lang=js&"
import style0 from "./ProductPartFour.vue?vue&type=style&index=0&id=43ae9659&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43ae9659",
  null
  
)

export default component.exports